import { ModalInfoHtml } from "@components/modals/modal-info/indexHtml";
import { htmlFeeExternal } from "@components/modals/modal-messages/financial/feeExternal";
import { htmlFeeInternal } from "@components/modals/modal-messages/financial/feeInternal";
import { htmlProfit } from "@components/modals/modal-messages/financial/Profit";
import { ReactNode } from "react";
import { IconType } from "react-icons";
import {
  FaBuilding,
  FaChartLine,
  FaGift,
  FaGlobe,
  FaShoppingCart,
  FaWallet,
} from "react-icons/fa";

export type FinancialProjectionInfoKey =
  | "revenue"
  | "rewards"
  | "externalFees"
  | "platformFees"
  | "campaignPurchase"
  | "netProfit";

type FinancialProjectionInfo = {
  title: string;
  html: ReactNode;
  icon: IconType;
  color: string;
};

const financialProjectionInfo: Record<
  FinancialProjectionInfoKey,
  FinancialProjectionInfo
> = {
  revenue: {
    title: "Arrecadação Estimada",
    html: <p>Total bruto estimado ao vender todos os tickets da campanha.</p>,
    icon: FaChartLine,
    color: "text-success",
  },
  rewards: {
    title: "Valor Total em Prêmios",
html: (
      <p>
        Valor total pago, ou que será pago, pela premiação desta campanha.
      </p>
    ),
    icon: FaGift,
    color: "text-warning",
  },
  externalFees: {
    title: "Taxas Externas",
    html: htmlFeeExternal(),
    icon: FaGlobe,
    color: "text-info",
  },
  platformFees: {
    title: "Taxas da Plataforma",
    html: htmlFeeInternal(),
    icon: FaBuilding,
    color: "text-primary",
  },
  campaignPurchase: {
    title: "Aquisição da Campanha",
    html: <p>Valor inicial pago no ato da criação da campanha.</p>,
    icon: FaShoppingCart,
    color: "text-warning",
  },
  netProfit: {
    title: "Lucro Líquido Estimado",
    html: htmlProfit(),
    icon: FaWallet,
    color: "text-success",
  },
};

type FinancialProjectionInfoButtonProps = {
  item: FinancialProjectionInfoKey;
  onOpen: () => void;
};

type FinancialProjectionInfoModalProps = {
  item?: FinancialProjectionInfoKey;
  onClose: () => void;
};

export function FinancialProjectionInfoButton({
  item,
  onOpen,
}: FinancialProjectionInfoButtonProps) {
  const info = financialProjectionInfo[item];
  const Icon = info.icon;

  return (
    <button
      type="button"
      className={`btn p-1 border-0 bg-transparent fs-4 lh-1 ${info.color}`}
      onClick={(event) => {
        event.stopPropagation();
        onOpen();
      }}
      title={`Entenda: ${info.title}`}
      aria-label={`Entenda: ${info.title}`}
    >
      <Icon aria-hidden="true" />
    </button>
  );
}

export function FinancialProjectionInfoModal({
  item,
  onClose,
}: FinancialProjectionInfoModalProps) {
  const info = item ? financialProjectionInfo[item] : undefined;

  return (
    <ModalInfoHtml
      isOpen={Boolean(info)}
      onClose={onClose}
      header="Projeção Financeira"
      title={info?.title || ""}
      html={info?.html || null}
    />
  );
}